import {createAsyncThunk, createSlice, isAnyOf, PayloadAction} from '@reduxjs/toolkit';
import {IErrorResult, IServerError} from '../../../../interface/Basic/api';
import {
    confirmNewCorporateEmail,
    confirmNewEmail,
    confirmNewPhone,
    getCorporateEmails,
    getEmail, getLKLink,
    getPassword,
    getPhone,
    retryNewCorporateEmailCode,
    retryNewEmailCode,
    retryNewPhoneSMS,
    sendNewCorporateEmail,
    sendNewEmail,
    sendNewPhone,
    setNewPassword
} from './api';
import {
    IConfirmNewCorporateEmailResponse,
    IConfirmNewEmailRequest,
    IConfirmNewEmailResponse,
    IConfirmNewPhoneRequest,
    IConfirmNewPhoneResponse,
    IEditPasswordRequest,
    IGetCorporateEmailsResponse,
    IGetEmailResponse,
    IGetPasswordResponse,
    IGetPhoneResponse,
    ISendEmailRequest,
    ISendEmailResponse,
    ISendPhoneRequest,
    ISendPhoneResponse,
} from "../../../../interface/Passport/Security/backend";
import {APIStatusEnum} from "../../../../enum/api";
import {
    IErrorResultWithRetryData,
    IGetLKLinkResponse,
    IServerErrorWithRetryData
} from "../../../../interface/Auth/backend";
import {ISecurityState} from "../../../../interface/Passport/Security/frontend";


export const GetPhone = createAsyncThunk<IGetPhoneResponse, undefined, { rejectValue: IErrorResult }>
('getPhone', (data, thunkAPI) => getPhone()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const GetEmail = createAsyncThunk<IGetEmailResponse, undefined, { rejectValue: IErrorResult }>
('getEmail', (data, thunkAPI) => getEmail()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))


export const SendNewPhone = createAsyncThunk<ISendPhoneResponse, ISendPhoneRequest, { rejectValue: IErrorResultWithRetryData }>
('SendPhone', (data, thunkAPI) => sendNewPhone(data)
    .then(resolve => resolve)
    .catch((error: IServerErrorWithRetryData) => {
        if (error.response.data.error.status === APIStatusEnum.TooManyRequests) {
            error.response.data.error.retryData = error.response.headers['retry-after'];
        }
        return thunkAPI.rejectWithValue(error.response.data.error)
    }))

export const ConfirmNewPhone = createAsyncThunk<IConfirmNewPhoneResponse, IConfirmNewPhoneRequest, { rejectValue: IErrorResult }>
('confirmNewPhone', (data, thunkAPI) => confirmNewPhone(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const RetryNewPhoneSms = createAsyncThunk<ISendPhoneResponse, ISendPhoneRequest, { rejectValue: IErrorResultWithRetryData }>
('retryNewPhoneSMS', (data, thunkAPI) => retryNewPhoneSMS(data)
    .then(resolve => resolve)
    .catch((error: IServerErrorWithRetryData) => {
        if (error.response.data.error.status === APIStatusEnum.TooManyRequests) {
            error.response.data.error.retryData = error.response.headers['retry-after'];
        }
        return thunkAPI.rejectWithValue(error.response.data.error)
    }))


export const SendNewEmail = createAsyncThunk<ISendEmailResponse, ISendEmailRequest, { rejectValue: IErrorResultWithRetryData }>
('SendEmail', (data, thunkAPI) => sendNewEmail(data)
    .then(resolve => resolve)
    .catch((error: IServerErrorWithRetryData) => {
        if (error.response.data.error.status === APIStatusEnum.TooManyRequests) {
            error.response.data.error.retryData = error.response.headers['retry-after'];
        }
        return thunkAPI.rejectWithValue(error.response.data.error)
    }))

export const ConfirmNewEmail = createAsyncThunk<IConfirmNewEmailResponse, IConfirmNewEmailRequest, { rejectValue: IErrorResult }>
('confirmNewEmail', (data, thunkAPI) => confirmNewEmail(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const RetryNewEmailCode = createAsyncThunk<ISendEmailResponse, ISendEmailRequest, { rejectValue: IErrorResultWithRetryData }>
('retryNewEmailCode', (data, thunkAPI) => retryNewEmailCode(data)
    .then(resolve => resolve)
    .catch((error: IServerErrorWithRetryData) => {
        if (error.response.data.error.status === APIStatusEnum.TooManyRequests) {
            error.response.data.error.retryData = error.response.headers['retry-after'];
        }
        return thunkAPI.rejectWithValue(error.response.data.error)
    }))

export const GetPassword = createAsyncThunk<IGetPasswordResponse, undefined, { rejectValue: IErrorResult }>
('getPassword', (data, thunkAPI) => getPassword()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const SetNewPassword = createAsyncThunk<IGetPasswordResponse, IEditPasswordRequest, { rejectValue: IErrorResult }>
('setNewPassword', (data, thunkAPI) => setNewPassword(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))


export const GetCorporateEmails = createAsyncThunk<IGetCorporateEmailsResponse, undefined, { rejectValue: IErrorResult }>
('getCorporateEmails', (data, thunkAPI) => getCorporateEmails()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))


export const SendNewCorporateEmail = createAsyncThunk<ISendEmailResponse, ISendEmailRequest, { rejectValue: IErrorResultWithRetryData }>
('SendCorporateEmail', (data, thunkAPI) => sendNewCorporateEmail(data)
    .then(resolve => resolve)
    .catch((error: IServerErrorWithRetryData) => {
        if (error.response.data.error.status === APIStatusEnum.TooManyRequests) {
            error.response.data.error.retryData = error.response.headers['retry-after'];
        }
        return thunkAPI.rejectWithValue(error.response.data.error)
    }))

export const ConfirmNewCorporateEmail = createAsyncThunk<IConfirmNewCorporateEmailResponse, IConfirmNewEmailRequest, { rejectValue: IErrorResult }>
('confirmNewCorporateEmail', (data, thunkAPI) => confirmNewCorporateEmail(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const RetryNewCorporateEmailCode = createAsyncThunk<ISendEmailResponse, ISendEmailRequest, { rejectValue: IErrorResultWithRetryData }>
('retryNewCorporateEmailCode', (data, thunkAPI) => retryNewCorporateEmailCode(data)
    .then(resolve => resolve)
    .catch((error: IServerErrorWithRetryData) => {
        if (error.response.data.error.status === APIStatusEnum.TooManyRequests) {
            error.response.data.error.retryData = error.response.headers['retry-after'];
        }
        return thunkAPI.rejectWithValue(error.response.data.error)
    }))

export const GetLKLink = createAsyncThunk<IGetLKLinkResponse, void, { rejectValue: IErrorResult }>
('GetLKLink', (data, thunkAPI) => getLKLink()
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

const initialState: ISecurityState = {
    phone: '',
    email: '',
    smsPending: false,
    codePending: false,
    retryAfter: 30,
    error: {},
    isSecurityInputSend: false,
    isCodeRight: false,
    passwordDate: null,
    corporateEmails: [],
    lkLink: null,
}

export const slice = createSlice({
    name: 'security',
    initialState,
    reducers:
        {
            setIsSecurityInputSend(state) {
                state.isSecurityInputSend = false
            },
            setIsCodeRight(state) {
                state.isCodeRight = false
            },
            cleanError(state, action: PayloadAction<string>) {
                delete state.error[action.payload]
            },
            cleanAllErrors(state) {
                state.error = {}
            },
            setCorporateEmails(state, action) {
                state.corporateEmails = action.payload
            },
        },
    extraReducers: (builder) => {
        builder.addCase(GetPhone.fulfilled, (state, action) => {
            state.phone = action.payload.data;
        })

        builder.addCase(ConfirmNewPhone.fulfilled, (state, action) => {
            state.phone = action.payload.data;
            state.isCodeRight = true
        })

        builder.addCase(SendNewPhone.fulfilled, (state, action) => {
            state.retryAfter = action.payload.data
            state.isSecurityInputSend = true
        })

        builder.addCase(SendNewPhone.rejected, (state, action) => {
            if (action.payload?.status === APIStatusEnum.TooManyRequests) {
                state.retryAfter = action.payload?.retryData
                state.isSecurityInputSend = true
            }
        })

        builder.addCase(RetryNewPhoneSms.pending, (state) => {
            state.smsPending = true
        })
        builder.addCase(RetryNewPhoneSms.fulfilled, (state, action) => {
            state.retryAfter = action.payload.data
            state.smsPending = false
        })
        builder.addCase(RetryNewPhoneSms.rejected, (state, action) => {
            if (action.payload?.status === APIStatusEnum.TooManyRequests) {
                state.retryAfter = action.payload?.retryData
            }
            state.smsPending = false
        })

        builder.addCase(GetEmail.fulfilled, (state, action) => {
            state.email = action.payload.data;
        })
        builder.addCase(ConfirmNewEmail.fulfilled, (state, action) => {
            state.email = action.payload.data;
            state.isCodeRight = true
        })

        builder.addCase(SendNewEmail.fulfilled, (state, action) => {
            state.retryAfter = action.payload.data
            state.isSecurityInputSend = true
        })
        builder.addCase(SendNewEmail.rejected, (state, action) => {
            if (action.payload?.status === APIStatusEnum.TooManyRequests) {
                state.retryAfter = action.payload?.retryData
                state.isSecurityInputSend = true
            }
        })

        builder.addCase(RetryNewEmailCode.pending, (state) => {
            state.codePending = true
        })
        builder.addCase(RetryNewEmailCode.fulfilled, (state, action) => {
            state.retryAfter = action.payload.data
            state.codePending = false
        })
        builder.addCase(RetryNewEmailCode.rejected, (state, action) => {
            if (action.payload?.status === APIStatusEnum.TooManyRequests) {
                state.retryAfter = action.payload?.retryData
            }
            state.codePending = false
        })

        builder.addCase(GetCorporateEmails.fulfilled, (state, action) => {
            state.corporateEmails = action.payload.data;
        })

        builder.addCase(ConfirmNewCorporateEmail.fulfilled, (state, action) => {
            state.corporateEmails = action.payload.data;
            state.isCodeRight = true
        })

        builder.addCase(SendNewCorporateEmail.fulfilled, (state, action) => {
            state.retryAfter = action.payload.data
            state.isSecurityInputSend = true
        })
        builder.addCase(SendNewCorporateEmail.rejected, (state, action) => {
            if (action.payload?.status === APIStatusEnum.TooManyRequests) {
                state.retryAfter = action.payload?.retryData
                state.isSecurityInputSend = true
            } else {
                state.isSecurityInputSend = false
            }
        })

        builder.addCase(RetryNewCorporateEmailCode.pending, (state) => {
            state.codePending = true
        })
        builder.addCase(RetryNewCorporateEmailCode.fulfilled, (state, action) => {
            state.retryAfter = action.payload.data
            state.codePending = false
        })
        builder.addCase(RetryNewCorporateEmailCode.rejected, (state, action) => {
            if (action.payload?.status === APIStatusEnum.TooManyRequests) {
                state.retryAfter = action.payload?.retryData
            }
            state.codePending = false
        })

        builder.addCase(GetPassword.fulfilled, (state, action) => {
            state.passwordDate = action.payload.data
        })

        builder.addCase(SetNewPassword.fulfilled, (state, action) => {
            state.passwordDate = action.payload.data
            state.isSecurityInputSend = true
        })
        builder.addCase(GetLKLink.fulfilled, (state, action) => {
            if (action.payload.data.link) {
                state.lkLink = action.payload.data.link
            }
        })

        builder.addMatcher(isAnyOf(
            SendNewEmail.rejected,
            SendNewPhone.rejected,
            ConfirmNewEmail.rejected,
            ConfirmNewPhone.rejected,
            SetNewPassword.rejected,
            SendNewCorporateEmail.rejected,
            ConfirmNewCorporateEmail.rejected,
        ), (state, action) => {
            if (action.payload?.fields) {
                Object.entries(action.payload.fields).forEach((item) => {
                    state.error[item[0]] = item[1] ? item[1][0] : ''
                })
            }
        })
    }
})

export const {
    setIsSecurityInputSend,
    setIsCodeRight,
    cleanError,
    cleanAllErrors,
    setCorporateEmails
} = slice.actions;

export default slice.reducer;